import React from "react";
import { css } from "@emotion/react";
import Img from "gatsby-image";
import { useStaticQuery, graphql } from "gatsby";
import Layout from "../components/Layout";
import SEO from "../components/Seo";
import SideProjectGrid from "../components/SideProjectGrid";

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      talksHero: file(relativePath: { eq: "one-foot-in-both-camps.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 800) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  return (
    <Layout>
      <SEO title="Home" />
      <h1>
        Jack Lo Russo&nbsp;—<br></br>designer & engineer from Sydney, Australia.
      </h1>
      <p className="fs-p1 bio-para">
        Currently working on the{" "}
        <a href="https://atlassian.design/">Atlassian Design&nbsp;System</a>.
      </p>
      <section>
        <h2
          css={css`
            padding-top: var(--scale-p3);
          `}
        >
          Side projects and experiments
        </h2>
        <SideProjectGrid />
      </section>
      <section>
        <h2
          css={css`
            padding-top: var(--scale-p3);
          `}
        >
          Talks
        </h2>
        <Img
          fluid={data.talksHero.childImageSharp.fluid}
          alt="Jack presenting a meetup talk with a microphone in hand. A projector screen shows a diagram that illustrates overlapping skillsets in 'Research', 'Design', 'Front End' and 'Back End', representing a small cross-functional team."
          css={css`
            margin-top: var(--scale-p3);
          `}
        />
        <h3 className="talk-heading fw-400">
          &ldquo;The Dark Web&rdquo; — using the prefers-color-scheme CSS media
          feature
        </h3>
        <p>SydCSS, Sydney, December 2019</p>

        <h3 className="talk-heading fw-400">
          One foot in both camps — navigating a career as a Design/Dev hybrid
        </h3>
        <p>
          <a href="https://www.invisionapp.com/design-exchange/">
            InVision Design Exchange Conference
          </a>
          , Sydney, October 2019
        </p>
        <p
          css={css`
            margin-top: var(--scale-m4);
          `}
        >
          <a href="https://designsystemmeetup.com/v10.0.0/">
            Design System Meetup v10.0.0
          </a>
          , Sydney, September 2019
        </p>
        <p
          css={css`
            margin-top: var(--scale-base);
          `}
        >
          <a href="https://vimeo.com/358956867">Watch on Vimeo</a>
        </p>

        <h3 className="talk-heading fw-400">
          What is the Accessibility Tree? (Lightning Talk)
        </h3>
        <p>RORO (Ruby on Rails Oceania) Meetup, Sydney, February 2019</p>

        <h3 className="talk-heading fw-400">
          Inspecting the Accessibility Inspector
        </h3>
        <p>
          A11yBytes on Global Accessibility Awareness Day, Sydney, April 2018
        </p>
        <p
          css={css`
            margin-top: var(--scale-base);
          `}
        >
          <a href="https://www.youtube.com/watch?v=apAnOeNeCl0&t=238s">
            Watch on YouTube
          </a>
        </p>

        <h3 className="talk-heading fw-400 ">Design Systems for Small Teams</h3>
        <p>Design System Meetup v1.0.0, Sydney, March 2018</p>
        <p
          css={css`
            margin-top: var(--scale-base);
          `}
        >
          <a href="https://www.youtube.com/watch?v=t1_tA2CqcMw&t=1s">
            Watch on YouTube
          </a>
        </p>
      </section>
    </Layout>
  );
};

export default IndexPage;
